<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true" >
      {{ snackbar_message }}
    </v-snackbar>

    <v-form
      ref="form"
      lazy-validation
      @submit.prevent="newGeneralConfig()"
      class="mt-3">

      <v-card flat>
        <v-card-title>
         <h6 class="primary--text">Configurations générales</h6>
        <v-spacer></v-spacer>
        <span v-if="is_config_exists && read_ongoing">
          <v-btn
            rounded
            color="primary"
            class="text-capitalize"
            @click="setEdition"
            v-if="$can('create settings')">
            Editer les paramètres
            <v-icon right>mdi-pencil-outline</v-icon>
          </v-btn>
        </span>
        <span v-else-if="is_config_exists && read_ongoing==false">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            color="info"
            class="text-capitalize"
            @click="setInputToReadonly">
            Annuler
            <v-icon right>mdi-close-circle</v-icon>
          </v-btn>
        </span>

        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs6 sm4>
                <v-subheader>Logo de la compagnie</v-subheader>
              </v-flex>
              <v-flex xs6 sm8 text-center>
                <div v-if="is_config_exists && read_ongoing">
                  <v-avatar size="160px">
                    <img :src="general.logo_url" alt="Logo" >
                  </v-avatar>
                </div>

                <div v-else>
                  <image-input v-model="avatar">
                    <div slot="activator">
                    <v-avatar size="160px" v-ripple v-if="!avatar" class="grey lighten-3 mb-3">
                        <span>Cliquez pour ajouter une image</span>
                    </v-avatar>
                    <v-avatar size="160px" v-ripple v-else class="mb-3">
                        <img :src="avatar.imageURL" alt="Logo" >
                    </v-avatar>
                    </div>
                  </image-input>
                </div>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Nom de l'application</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field
                  v-model="general.app_name"
                  label="Nom de l'application"
                  :readonly="readonly_app_name"
                  solo></v-text-field>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Nom de la compagnie</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field
                  v-model="general.company_name"
                  label="Nom de la compagnie"
                  :readonly="readonly_company_name"
                  solo></v-text-field>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Pays</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-select
                  v-model="general.country_id"
                  :items="countries"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Pays requis']"
                  label="Pays"
                  :readonly="readonly_country_id"
                  solo></v-select>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Adresse physique</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field
                  v-model="general.address"
                  label="Adresse physique de la compagnie"
                  :readonly="readonly_address"
                  solo></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>


      <v-card class="mt-5" flat>
        <v-card-title>
          <h6 class="primary--text">Configuration d'email</h6>
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs6 sm4>
                <v-subheader>Titre de l'email</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field
                  v-model="general.mail_subject"
                  label="Titre de l'email"
                  :readonly="readonly_mail_subject"
                  solo></v-text-field>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Adresse email d'envoi</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field
                  v-model="general.mail_address"
                  v-validate="'email'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  label="Adresse d'envoi"
                  :readonly="readonly_mail_address"
                  solo></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <div class="text-center mt-1">
        <v-btn rounded color="primary" type="submit" v-if="$can('create settings')">Enregistrer</v-btn>
      </div>

    </v-form>

    <br> <br> <br>

  </div>
</template>

<script>
import ImageInput from '~/components/ImageInput.vue'
import Permissions from '~/mixins/Permissions';

export default {
  name: 'create-general',
  mixins: [Permissions],
  components: {
    ImageInput: ImageInput
  },

  data: () => ({
    avatar: null,
    saving: false,
    saved: false,
    loading: false,
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    is_config_exists: false,
    read_ongoing: true,

    readonly_app_name: false,
    readonly_company_name: false,
    readonly_country_id: false,
    readonly_address: false,
    readonly_mail_subject: false,
    readonly_mail_address: false,
  }),


  computed: {
    countries () { return this.$store.getters.countries; },

    general () {
      let configuration =  this.$store.getters.getGeneralConfig;
      // console.log("Current config data ", configuration);

      // if(Object.keys(configuration).length !== 0 && configuration.constructor !== Object){
      if(Object.keys(configuration).length !== 0 ){
        this.is_config_exists = true;
        this.read_ongoing = false;
        this.setInputToReadonly();
        return configuration;
      }
      else{
        let objet = {};
        return objet;
      }
    },
  },

  watch:{
    avatar: {
      handler: function() {
        this.saved = false
      },
      deep: true
    }
  },


  created () {
    this.fetchUtils();
  },


  methods: {
    fetchUtils () {
        this.$store.dispatch("fetchCountries");
        this.$store.dispatch("loadGeneralConfig");
    },

    async newGeneralConfig(){
      if (await this.formHasErrors()) return

      if(this.avatar == null || this.general.app_name == null ||
        this.general.company_name == null ||
        this.general.address == null || this.general.mail_subject == null ||
        this.general.mail_address == null)
      {
        this.snackbar = true;
        this.snackbar_color = 'error';
        this.snackbar_message = "Veuillez remplir tous les champs avant de poursuivre";
        return ;
      }
      else{
        this.general.logo_url = this.avatar.imageFile;

        if(this.is_config_exists){
          this.$store.dispatch('updateGeneralConfig', this.general);
          this.snackbar_message = "Paramètres édités avec succès !";
        }
        else{
          this.$store.dispatch('storeGeneralConfig', this.general);
          this.snackbar_message = "Paramètres créés avec succès !";
        }
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.is_config_exists = true;
        this.setInputToReadonly();
      }
    },

    setInputToReadonly(){
        this.read_ongoing = true;
        this.readonly_app_name = true;
        this.readonly_company_name = true;
        this.readonly_country_id = true;
        this.readonly_address = true;
        this.readonly_mail_subject = true;
        this.readonly_mail_address = true;
    },

    setEdition(){
        this.read_ongoing = false;
        this.readonly_app_name = false;
        this.readonly_company_name = false;
        this.readonly_country_id = false;
        this.readonly_address = false;
        this.readonly_mail_subject = false;
        this.readonly_mail_address = false;

        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Vous pouvez maintenant éditer les paramètres";
    },

  }
};
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/general.vue